import main from "./modules/main";
import cart from "./modules/cart/index";
import userData from "./modules/userData";
import applicationUser from "./modules/applicationUser";
import shop from "./modules/shop/shop";
import admin from "./modules/admin";
import ingredients from "./modules/admin/ingredients";
import productsIngredients from "./modules/admin/productsIngredients";
import foodCategories from "./modules/admin/foodCategories";
import orderControlPanel from "./modules/admin/orderControlPanel";
import shops from "./modules/admin/shops";
import product from "./modules/product/product";
import timezones from "./modules/timezones/timezones";
import person from "./modules/person/person";
import localization from "./modules/localization";
import device from "./modules/device";
import UI from "./modules/UI";
import productSelections from "./modules/productSelections";
import upsellRules from "./modules/upsellRules";
import termsAndConditions from "./modules/termsAndConditions";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import appConfig from "../appconfig";
import { i18nInitializer } from "../providers/localization/i18nProvider";
import abTests from "./modules/abTests";
import gigya from "./modules/gigya";

const hasLocalStorage = function() {
	try {
		localStorage.setItem("testingLocalStorage","1");
		return true;
	} catch(err) {
		return false;
	}
};

const MyStore = async ({
	enrichedProductCatalogData,
	serverData,
	priceRules,
	featureToggles,
	globalVersions
}) => {
	// we are using window.TENANT_ID because of webpack dynamic import() mechanism
	const bmId = appConfig.getBusinessModelId().toUpperCase();
	const tenantId = appConfig.tenantConfig.tenantId;
	const specificModules = appConfig.tenantConfig.isSGTenant ?
		((await import(`./tenantSpecificModules/storeModulesTid${tenantId}/index`)).default) :
		((await import(`./globalTemplateSpecificModules/storeModules${bmId}/index`)).default);

	const plugins = [];
	if (hasLocalStorage()) {
		// check if we need to remove local storage
		const lastLocalStorageRemoval = parseInt(localStorage.getItem("lastLocalStorageRemoval"));
		const removeLocalStorageDataAfterTimestamp = serverData.tenantSettings.removeLocalStorageDataAfterTimestamp;

		if (isNaN(lastLocalStorageRemoval) ||
			typeof removeLocalStorageDataAfterTimestamp === "number" && lastLocalStorageRemoval < removeLocalStorageDataAfterTimestamp
		) {
			localStorage.setItem("lastLocalStorageRemoval", Date.now().toString());
			localStorage.removeItem("vuex");
			console.log("Local storage reset completed"); // eslint-disable-line no-console
		}

		plugins.push(createPersistedState({
			paths: [
				"cart.persistedData",
				"userData.isPersisted",
				"userData.loginHistory",
				"userData.isFirstLogin",
				"userData.authFlow",
				"applicationUser.persistedData",
				"userData.persistedData",
				"userData.editModeData",
				"admin.persistedData",
				"orderControlPanel",
				"shop.persistedData",
				"product.persistedData",
				"timezones.persistedData",
				"person.persistedData",
				"localization.persistedData",
				"device.persistedData",
				"UI.persistedData",
				"device.peristedData",
				"upsellRules.persistedData",
				"abTests.persistedData",
				"main.persistedData",
				...specificModules.persistedDataPaths
			]
		}));
	}

	const vuexStoreStrict = appConfig.env.NODE_ENV !== "production" && appConfig.env.NODE_ENV !== "testing";

	const vuexStore =  new Vuex.Store({
		plugins: plugins,
		modules: {
			main: main({
				enrichedProductCatalogData,
				priceRules,
				serverData,
				featureToggles,
				localization,
				device,
				globalVersions
			}),
			cart,
			userData,
			applicationUser,
			admin,
			ingredients,
			productsIngredients,
			foodCategories,
			orderControlPanel,
			shop,
			shops,
			product,
			timezones,
			person,
			...specificModules.storeModules,
			localization,
			device,
			UI,
			productSelections,
			upsellRules,
			termsAndConditions,
			abTests,
			gigya
		},
		strict: vuexStoreStrict
	});
	// function that should be called on tenant upon setting up vuex store
	// for example, for tenant 100 it is used to set up interval for checking if the cart
	// has been updated since the last update
	if(typeof specificModules.tenantStartupActions === "function"){
		specificModules.tenantStartupActions(vuexStore);
	}

	if (appConfig.mobile.isMobileApp()) {
		const hasAppDownloaded = window.localStorage.getItem("hasAppDownloaded");
		window.localStorage.setItem("hasAppDownloaded", hasAppDownloaded || ((vuexStore.getters.countriesInfo || []).length > 0 ? "1" : "0"));
	}

	const isAdmin = window.location.pathname.includes("admin") || false;
	i18nInitializer(vuexStore, isAdmin);

	return vuexStore;
};

export default MyStore;
